import React, { FC } from 'react';
import RefundManagementProps from 'Feature/Claims/models/RefundManagementProps';

const RefundManagement: FC<RefundManagementProps> = () => <p>RefundManagement Component</p>;

export default RefundManagement;
